var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJobseeker3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.213 13.1275L24.1905 12.958C23.415 7.2825 24.926 1.6635 14.345 3.293C3.66147 4.934 7.78097 9.851 7.78097 14.7685V14.8985C7.84297 18.169 10.576 22.775 15.9855 28.705C22.012 22.1415 24.7565 16.947 24.213 13.1275ZM16.3535 14.5305C13.9485 14.5305 11.9795 12.731 11.9795 10.5075C11.9795 8.2895 13.9375 6.49 16.3535 6.49C18.781 6.49 20.733 8.2895 20.733 10.5075C20.733 12.7315 18.764 14.5305 16.3535 14.5305Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1081 7.74097C19.2531 6.90997 17.7526 6.55697 15.5761 6.71247L15.3611 6.73047H15.3131C13.7106 6.70647 11.3136 8.99647 11.5226 10.6825C11.5761 12.1235 13.3221 14.019 15.8091 14.288C18.0516 14.3955 19.3726 14.15 20.1561 13.278C20.7156 12.524 21.0311 11.616 21.0586 10.6775V10.432C21.1226 9.95897 21.0961 9.47847 20.9811 9.01497L20.9331 8.86597L20.8791 8.74647C20.7421 8.46047 20.5626 8.19647 20.3471 7.96347L20.2276 7.84947L20.1081 7.74097Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2569 4.31603C17.9374 2.65303 14.0479 2.56203 10.6539 4.06753L10.4939 4.14503L10.3614 4.23903C5.16242 7.88703 6.91743 15.642 15.8919 27.6245L16.1569 27.972L16.3779 28.2645L16.6264 27.9275C19.6804 23.749 22.1434 19.169 23.9444 14.317L24.1209 13.826L24.2809 13.357C24.6999 12.054 24.8224 10.6735 24.6399 9.31703C24.4639 7.17603 23.1834 5.28253 21.2619 4.32203V4.31603H21.2569Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52441 28.565C9.52441 28.565 19.6864 28.887 21.8534 28.653",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJobseeker3);
export default __webpack_public_path__ + "static/media/icon_jobseeker_3.512635d9de5bed4cc3aaec3cfa3006e3.svg";
export { ForwardRef as ReactComponent };